import { Settings } from './settings';

export interface Mills {
	millCode: string;
	settings: Settings[];
}

interface TransportModeDetails {
	code: number;
	description: string;
	name: string;
}
export const staticTransportModeValues = new Map<string, TransportModeDetails>([
	['MARIT', { code: 1, description: 'MARIT', name: 'tmode.bysea' }],
	['FER', { code: 2, description: 'FER', name: 'tmode.rail' }],
	['CAM', { code: 3, description: 'CAM', name: 'tmode.lorry' }],
	['FLUV', { code: 5, description: 'FLUV', name: 'tmode.inlandwaterway' }],
]);
